import { render, staticRenderFns } from "./LinksBaboon.vue?vue&type=template&id=18f6c61e&scoped=true"
import script from "./LinksBaboon.vue?vue&type=script&lang=js"
export * from "./LinksBaboon.vue?vue&type=script&lang=js"
import style0 from "./LinksBaboon.vue?vue&type=style&index=0&id=18f6c61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6c61e",
  null
  
)

export default component.exports